import React from "react";

export const getMeasureTitle = (id) => {
    switch(id) {
        case 100:
            return "None";
        case 1:
            return "Sets";
        case 2:
            return "Repetitions"
        case 3:
            return "Rest"
        case 5:
            return "Reps per side"
        case 10:
            return "Pounds (Lbs)";
        case 11:
            return "Kilograms (Kgs)"
        case 12:
            return "Percent of Max (%)"
        case 20:
            return "Time (Min:Sec)";
        case 21:
            return "Seconds (Secs)"
        case 30:
            return "Feet"
        case 31:
            return "Yards";
        case 32:
            return "Miles"
        case 33:
            return "Inches"
        case 34:
            return "Meters"
        case 35:
            return "Height in Inches (Height)";
        case 36:
            return "Laps"
        case 40:
            return "Calories (Cals)"
        case 41:
            return "Velocity in meters/second"
        case 42:
            return "Velocity miles/hour"
        case 43:
            return "Velocity kilometers/hour";
        case 44:
            return "Watts"
        case 45:
            return "Breaths"
        case 46:
            return "Breaths per side"
        case 47:
            return "Seconds per side"
        case 48:
            return "Rate of Perceived Exertion"
        default:
            return "Select"
      }
  }



// WEBPACK FOOTER //
// ./src/utils/Measure.js